import { schema } from 'normalizr'

const shopOrder = new schema.Entity('shopOrders', {})

export default shopOrder
